
module.exports = {
    baseApi: require('./base.req'),
    aboutApi: require('./about.req'),
    orderApi: require('./order.req'),
    columnApi: require('./column.req'),
    faWuApi: require('./faWu.req'),
    joinApi: require('./join.req')
}